import { ESTADOS } from "@/lib/solicitudes";

export const EstadoBadge = ({ estado, testid = "solicitud-estado" }) => {
  const e = ESTADOS[estado] || ESTADOS.pendiente;
  return <span data-testid={testid} className={`shrink-0 text-[10px] font-bold uppercase tracking-wide px-2 py-0.5 rounded-full border ${e.cls}`}>{e.label}</span>;
};
